module.exports = __webpack_public_path__ + "img/dice-cubes1.e837d41c.svg";